type ReportPaginationProps = {
  currentPage: number
  totalPages: number
  totalRecords: number
  pageSize: number
  onPageChange: (page: number) => void
}

export const ReportPagination = ({
  currentPage,
  totalPages,
  totalRecords,
  pageSize,
  onPageChange,
}: ReportPaginationProps) => {
  if (!totalRecords) {
    return null
  }

  const startRecord = (currentPage - 1) * pageSize + 1
  const endRecord = Math.min(currentPage * pageSize, totalRecords)
  const pageNumbers = []
  const startPage = Math.max(1, currentPage - 1)
  const endPage = Math.min(totalPages, currentPage + 1)

  for (let page = startPage; page <= endPage; page += 1) {
    pageNumbers.push(page)
  }

  return (
    <div className='d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-4 pt-6'>
      <div className='text-muted fs-7'>
        Showing {startRecord}-{endRecord} of {totalRecords}
      </div>

      <div className='d-flex align-items-center gap-2'>
        <button
          type='button'
          className='btn btn-sm btn-light'
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Previous
        </button>

        {pageNumbers.map((page) => (
          <button
            key={page}
            type='button'
            className={`btn btn-sm ${page === currentPage ? 'btn-primary' : 'btn-light'}`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        ))}

        <button
          type='button'
          className='btn btn-sm btn-light'
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  )
}
